import type { PaymentMethodsResponse } from './api';
import { isCardExpired } from './startCardExpiry';

/** Expiration includes the entire printed month, matching the pre-session check (startCardExpiry.ts).
 * This decides whether to ASK; it never selects or substitutes a default. */
export function needsExpiredDefaultPrompt(current: PaymentMethodsResponse | undefined, addedId: string | null,
  now = new Date()): boolean {
  if (!addedId || !current?.default_payment_method || current.default_payment_method === addedId) return false;
  return isCardExpired(current.payment_methods.find(card => card.id === current.default_payment_method), now);
}

export function confirmedSetupCard(intent?: { status: string; payment_method: string | { id: string } | null } | null): string | null {
  if (intent?.status !== 'succeeded') return null;
  return typeof intent.payment_method === 'string' ? intent.payment_method : intent.payment_method?.id ?? null;
}

/** Strip bank-return secrets from the address bar before retrieving status. */
export function setupCardReturn(url: URL): { secret: string | null; cleanUrl: string } {
  const clean = new URL(url), secret = clean.searchParams.get('setup_intent_client_secret');
  for (const key of ['setup_intent', 'setup_intent_client_secret', 'redirect_status']) clean.searchParams.delete(key);
  return { secret, cleanUrl: clean.href };
}
